module.exports = __webpack_public_path__ + "img/card-tickets.0224b4bd.svg";